module.exports = {
	"id": "abt577",
	"enabled": true,
	"type": "standard",
	"split": 1,
	"dateRange": [
		{
			"start": "2016-04-12T09:00:00-05:00",
			"end": "2016-05-12T23:59:59-05:00"
		}
	],
	"cookieExpiration": "2016-05-22T23:59:59-05:00",
	"evar": {
		"number": 68,
		"qa": 68,
		"name": "header_usability",
		"skip": true
	},
	"deviceSize": [
		"s",
		"m",
		"l"
	],
	"customData": {
		"exclude": {
			"pageType": [
				"checkout",
				"geekSquad,repairStatus"
			]
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt577/config.json
 ** module id = 37
 ** module chunks = 2
 **/